document.addEventListener('DOMContentLoaded', function () {
  const progressContainer = document.querySelector('[data-rewards-progress]');
  if (!progressContainer) return;

  const message = progressContainer.querySelector('[data-rewards-message]');
  const bar = progressContainer.querySelector('.rewards-progress__bar');
  const steps = progressContainer.querySelectorAll('[data-reward-step]');

  const freeShipping = Number(progressContainer.dataset.freeShipping);
  const freeGlass = Number(progressContainer.dataset.freeGlass);
  const freeTshirt = Number(progressContainer.dataset.freeTshirt);
  const maxGoal = freeTshirt;

  // Cadourile, citite din formulare. Pragul vine din pasul in care se afla formularul.
  const gifts = Array.from(progressContainer.querySelectorAll('[data-gift-form]')).map(function (form) {
    return {
      form: form,
      btn: form.querySelector('[data-gift-btn]'),
      select: form.querySelector('[data-gift-select]'),
      productId: Number(form.dataset.giftProduct),
      threshold: Number(form.closest('[data-reward-step]').dataset.rewardStep),
      available: form.dataset.giftAvailable === 'true'
    };
  });

  let refreshTimer = null;
  let isEnforcing = false;

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('ro-RO', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' RON';
  }

  function isGiftItem(item) {
    return item && item.properties && String(item.properties._reward_gift) === 'true';
  }
  function findGift(item) {
    return gifts.find(gift => gift.productId === Number(item.product_id));
  }
  // "Taxa SGR" (garantia ambalajelor), adaugata automat de aplicatia de taxe (FeeBee).
  function isFeeItem(item) {
    return item && item.product_type === 'mws_fee_generated';
  }

  // Total pe produsele reale, FARA cadouri.
  // Taxa SGR intra in subtotalul de la checkout (prag livrare), dar reducerea
  // automata CADOU nu o numara -> pentru pragurile de cadou se exclude.
  function computeQualifyingTotal(cart, includeFees) {
    if (!cart || !cart.items) return 0;
    return cart.items
      .filter(item => !isGiftItem(item) && (includeFees || !isFeeItem(item)))
      .reduce((sum, item) => sum + item.final_line_price, 0);
  }

  function isGiftInCart(cart, gift) {
    if (!cart || !cart.items) return false;
    return cart.items.some(item => isGiftItem(item) && findGift(item) === gift);
  }

  // Ce modificari trebuie facute la cadouri (doar UX, reducerea automata verifica oricum pragul):
  //  - sub prag  -> quantity 0 (stergere)
  //  - al doilea rand cu acelasi cadou (ex. alta marime) -> stergere
  //  - altfel daca quantity > 1 -> quantity 1 (blocam la 1 bucata)
  function getGiftChanges(cart, qualifyingTotal) {
    const changes = [];
    const seen = [];
    cart.items.forEach(item => {
      if (!isGiftItem(item)) return;
      const gift = findGift(item);
      if (!gift) return;

      if (qualifyingTotal < gift.threshold || seen.includes(gift)) {
        changes.push({ id: item.key, quantity: 0 });
      } else if (item.quantity > 1) {
        changes.push({ id: item.key, quantity: 1 });
      }
      seen.push(gift);
    });
    return changes;
  }

  function changeCartLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(res => {
      if (!res.ok) throw new Error('Eroare la modificarea cosului.');
      return res.json();
    });
  }

  function updateGiftButton(gift, cartTotal, cart) {
    if (!gift.btn) return;
    let disabled = true;
    let label = 'Inactiv';
    let inCart = false;

    if (!gift.available) {
      label = 'Stoc epuizat';
    } else if (cartTotal < gift.threshold) {
      label = 'Inactiv';
    } else if (isGiftInCart(cart, gift)) {
      label = 'Adaugat ✓';
      inCart = true;
    } else {
      disabled = false;
      label = 'Adauga Cadou';
    }

    gift.btn.disabled = disabled;
    gift.btn.textContent = label;
    gift.btn.classList.toggle('in-cart', inCart);
    if (gift.select) gift.select.disabled = disabled;
  }

  function updateRewards(cart) {
    if (!cart) return;

    const cartTotal = computeQualifyingTotal(cart);
    const shippingTotal = computeQualifyingTotal(cart, true);

    const progress = Math.min((cartTotal / maxGoal) * 100, 100);
    if(bar) bar.style.setProperty('--progress', progress + '%');

    steps.forEach(function (step) {
      const stepValue = Number(step.dataset.rewardStep);
      const total = stepValue === freeShipping ? shippingTotal : cartTotal;
      step.classList.toggle('is-active', total >= stepValue);
    });

    gifts.forEach(gift => updateGiftButton(gift, cartTotal, cart));

    if (message) {
      if (cartTotal >= maxGoal) {
        message.textContent = 'Felicitări! Ai deblocat toate beneficiile 🎉';
      } else {
        let nextGoal = 0;
        let nextReward = '';
        let current = cartTotal;
        if (shippingTotal < freeShipping) {
          nextGoal = freeShipping; nextReward = 'Livrare Gratuita'; current = shippingTotal;
        } else if (cartTotal < freeGlass) {
          nextGoal = freeGlass; nextReward = 'Pahar gratuit';
        } else if (cartTotal < freeTshirt) {
          nextGoal = freeTshirt; nextReward = 'Tricou Bere Zaganu Cadou Gratuit';
        }
        message.textContent = 'Adauga produse de ' + formatMoney(nextGoal - current) + ' pentru ' + nextReward;
      }
    }
  }

  gifts.forEach(function (gift) {
    gift.form.addEventListener('submit', function (e) {
      e.preventDefault();

      // Nu adaugam o marime fara stoc
      if (gift.select) {
        const sel = gift.select.options[gift.select.selectedIndex];
        if (!sel || sel.disabled) return;
      }

      gift.btn.disabled = true;
      gift.btn.textContent = 'Se adauga...';

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(gift.form),
        headers: { 'Accept': 'application/json' }
      })
      .then(res => {
        if (!res.ok) throw new Error('Eroare server.');
        return res.json();
      })
      .then(() => {
        gift.btn.textContent = 'Adaugat ✓';
        gift.btn.classList.add('in-cart');
        window.location.reload();
      })
      .catch(err => {
        console.error(err);
        gift.btn.disabled = false;
        gift.btn.textContent = 'Adauga Cadou';
      });
    });
  });

  function refreshRewards() {
    if (isEnforcing) return;

    fetch('/cart.js', { cache: 'no-store' })
      .then(res => res.json())
      .then(cart => {
        const qualifyingTotal = computeQualifyingTotal(cart);
        const changes = getGiftChanges(cart, qualifyingTotal);

        if (changes.length > 0) {
          isEnforcing = true;
          let chain = Promise.resolve();
          changes.forEach(function (ch) {
            chain = chain.then(function () { return changeCartLine(ch.id, ch.quantity); });
          });
          chain
            .then(function () {
              window.location.reload();
            })
            .catch(function (err) {
              isEnforcing = false;
              console.error(err);
            });
        } else {
          updateRewards(cart);
        }
      })
      .catch(err => console.error(err));
  }

  function delayedRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshRewards, 300);
  }

  refreshRewards();

  const mutationObserver = new MutationObserver(function(mutations) {
    if (isEnforcing) return;
    const isOurModification = mutations.some(m => {
      const el = m.target.nodeType === 1 ? m.target : m.target.parentElement;
      return el && el.closest('.rewards-progress');
    });
    if (!isOurModification) {
      delayedRefresh();
    }
  });
  mutationObserver.observe(document.body, { childList: true, subtree: true, characterData: true });

  document.addEventListener('cart:updated', refreshRewards);
  document.addEventListener('cart:refresh', refreshRewards);
  document.addEventListener('cart:change', refreshRewards);
});
